import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-panel',
  templateUrl: './panel.component.html',
  styleUrls: ['./panel.component.less'],
})
export class PanelComponent {
  @Input() dialogRef: MatDialogRef<any>;
  @Input() isHuge: boolean;
  @Input() isMedium: boolean;
  @Output() isVisibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {}

  close() {
    this.dialogRef.close();
  }
}
